import { QuickIncomeSheet } from './QuickIncomeSheet';
import { useIncomeSheet } from '../../features/income/SheetProvider';
import { useSelfieCycle } from '../../store/SelfieCycleContext';

export function GlobalQuickIncomeSheet() {
  const { isOpen, close } = useIncomeSheet();
  const { currentCycle: activeCycle } = useSelfieCycle();

  return (
    <QuickIncomeSheet
      isOpen={isOpen}
      onClose={close}
      cycle={activeCycle}
    />
  );
}
